import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminTinCell = ({ client, token }) => {
  const [full, setFull] = useState('');
  if (!client.has_tax_id) return <span className="text-amber-400 text-xs" data-testid={`admin-tin-${client.client_id}`}>Not provided</span>;

  const toggle = async () => {
    if (full) return setFull('');
    try {
      const r = await axios.get(`${API}/pas-admin/clients/${client.client_id}/tax-id`, { headers: { Authorization: `Bearer ${token}` } });
      setFull(r.data.tax_id);
    } catch { toast.error('Could not load tax ID'); }
  };

  return (
    <div className="flex items-center gap-2">
      <code className="text-slate-300 text-sm" data-testid={`admin-tin-${client.client_id}`}>{full || client.tax_id_masked}</code>
      <span className="text-[10px] uppercase text-slate-500">{client.tax_id_type}</span>
      <button onClick={toggle} data-testid={`admin-tin-toggle-${client.client_id}`} className="text-xs text-purple-400 hover:text-purple-300">{full ? 'Hide' : 'Show'}</button>
    </div>
  );
};
